// extracted by mini-css-extract-plugin
export var collectionsCard = "collections-card-module--collectionsCard--d5bf3";
export var heading = "collections-card-module--heading--5c5ec";
export var text = "collections-card-module--text--2d75e";